import * as React from "react";

export const StyledHR = () => <hr className="border-opacity-50 border-allCitiesGray mb-2" />;
